export const RESTRICTED_AGENT_PROFILES = ['cofae', 'customer_service'];
export const SELECTABLE_AGENT_PROFILES = [
  ...RESTRICTED_AGENT_PROFILES,
  'controller',
];

export const agentPermissionSummaryKey = roleName => {
  if (roleName?.startsWith('custom_')) return 'CUSTOM';
  return ['administrator', 'agent', ...SELECTABLE_AGENT_PROFILES].includes(
    roleName
  )
    ? roleName.toUpperCase()
    : 'AGENT';
};

export const agentPermissionSummary = (t, roleName) => {
  switch (agentPermissionSummaryKey(roleName)) {
    case 'COFAE':
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.COFAE');
    case 'CUSTOMER_SERVICE':
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.CUSTOMER_SERVICE');
    case 'CONTROLLER':
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.CONTROLLER');
    case 'ADMINISTRATOR':
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.ADMINISTRATOR');
    case 'CUSTOM':
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.CUSTOM');
    default:
      return t('AGENT_MGMT.PERMISSIONS_GUIDE.SUMMARY.AGENT');
  }
};

export const agentProfileRoleId = agent => {
  if (
    agent.role === 'agent' &&
    SELECTABLE_AGENT_PROFILES.includes(agent.agent_profile)
  ) {
    return agent.agent_profile;
  }
  return agent.custom_role_id || agent.role;
};

export const agentProfilePayload = selected => {
  const isProfile = SELECTABLE_AGENT_PROFILES.includes(selected.name);
  const isCustom = selected.name.startsWith('custom_');
  return {
    role: isProfile || isCustom ? 'agent' : selected.name,
    agent_profile: isProfile ? selected.name : 'normal',
    custom_role_id: isCustom ? selected.id : null,
  };
};

export const agentProfileOptions = t =>
  SELECTABLE_AGENT_PROFILES.map(profile => ({
    id: profile,
    name: profile,
    label: t(`AGENT_MGMT.AGENT_TYPES.${profile.toUpperCase()}`),
  }));
